import { Button } from '@/components/ui/button';
import { useAdminNavigation } from '@/contexts/AdminNavigationContext';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface AdminPageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

const AdminPageHeader = ({ title, children }: AdminPageHeaderProps) => {
  const { isSidebarExpanded, setSidebarExpanded } = useAdminNavigation();
  const isMobile = useIsMobile();

  return (
    <div className="flex justify-between items-center min-h-10">
      <div className="flex items-center gap-2">
        {!isMobile && (
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 shrink-0"
            onClick={() => setSidebarExpanded?.(!isSidebarExpanded)}
          >
            {isSidebarExpanded ? (
              <ChevronLeft className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )}
          </Button>
        )}
        <h2 className="text-2xl font-bold">{title}</h2>
      </div>
      {children}
    </div>
  );
};

export default AdminPageHeader;
